import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Button from "../../components/Button";
import Card from "../../components/Card";
import Input from "../../components/Input";
import { api } from "../../services/api";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus] = useState("idle"); // idle, loading, success, error
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setStatus("error");
      setMessage("Passwords do not match");
      return;
    }

    if (password.length < 10) {
      setStatus("error");
      setMessage("Password must be at least 10 characters");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const response = await api.post("/auth/reset-password", {
        token,
        password,
      });
      setStatus("success");
      setMessage(response.message);
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (error) {
      setStatus("error");
      setMessage(error.error || "An error occurred. Please try again.");
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-background flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <Card className="py-8 px-4 sm:px-10 text-center">
            <h3 className="text-lg font-medium text-accent">Invalid Link</h3>
            <p className="mt-2 text-sm text-text opacity-80">
              This password reset link is invalid or missing. Please request a
              new one.
            </p>
            <div className="mt-6">
              <Link
                to="/forgot-password"
                className="font-medium text-primary hover:opacity-80"
              >
                Request new link
              </Link>
            </div>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-text">
          Set new password
        </h2>
        <p className="mt-2 text-center text-sm text-text opacity-80">
          Please enter your new password below.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card className="py-8 px-4 sm:px-10">
          {status === "success" ? (
            <>
              <p className="text-green-600 text-center font-medium">
                {message}
              </p>
              <p className="mt-2 text-sm text-text opacity-80 text-center">
                Redirecting to login...
              </p>
            </>
          ) : (
            <form className="space-y-6" onSubmit={handleSubmit}>
              <Input
                label="New Password"
                type="password"
                id="password"
                name="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Input
                label="Confirm New Password"
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {status === "error" && (
                <p className="text-red-500 text-center">{message}</p>
              )}
              <Button
                type="submit"
                loading={status === "loading"}
                className="w-full"
              >
                Reset Password
              </Button>
            </form>
          )}
        </Card>
      </div>
    </div>
  );
};

export default ResetPassword;
